module.exports = function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 if (data.has_report_switcher) { ;
__p += '\n<div class="report-switcher">\n    <span data-action="report:showall" class="fa-layers fa-fw show-reports-icon tooltipped-n tooltipped" aria-hidden="true" aria-label="' +
((__t = ( strings.reports_header_viewall_tooltip )) == null ? '' : __t) +
'">\n      <i class="far fa-reports filter-menu-icon"></i>\n      <i class="fas fa-chevron-down chevron-menu-icon" data-fa-transform="shrink-10 right-16"></i>\n    </span>\n    <span data-action="report:close" class="tooltipped-n tooltipped close-report-icon" aria-label="' +
((__t = ( strings.reports_header_close_tooltip )) == null ? '' : __t) +
'"><i class="fal fa-times"></i></span>\n</div>\n';
 } ;
__p += '\n';
 if (data.comparison_has_previous_page && !data.has_report_switcher) { ;
__p += '\n<div class="report-switcher close-only">\n    <span data-action="page:close_comparison" class="tooltipped-n tooltipped close-report-icon" aria-label="' +
((__t = ( strings.navigate_pack )) == null ? '' : __t) +
'"><i class="fal fa-times"></i></span>\n</div>\n';
 } ;
__p += '\n<div class="page-details-box">\n    ';
 if (data.section) { ;
__p += '\n    <h2 id="section-name">' +
__e( data.section ) +
'</h2>\n    ';
 } ;
__p += '\n    ';
 if (typeof data.name === "string") { ;
__p += '\n    <h1 id="page-name" ' +
((__t = ( !(data.section || data.description) ? "class='big'" : "" )) == null ? '' : __t) +
'>\n        ';
 if (data.showNameLoader) { ;
__p += '\n        <span class="name">\n            <div class="loader text-input__loading--line medium noMargin"></div>\n        </span>\n        ';
 } else { ;
__p += '\n        <span class="name">' +
__e( data.name ) +
'</span>\n        ';
 } ;
__p += '\n    </h1>\n    ';
 } ;
__p += '\n    ';
 if (data.description) { ;
__p += '\n    <h3 id="page-description">\n        ' +
__e( data.description ) +
'\n    </h3>\n    ';
 } ;
__p += '\n</div>\n';
 if (data.versionSwitch) { ;
__p += '\n<div class="versionSwitch">\n    ' +
((__t = ( data.versionSwitch )) == null ? '' : __t) +
'\n</div>\n';
 } ;
__p += '\n';
 if (data.actions) { ;
__p += '\n<div class="actions">\n    ' +
((__t = ( data.actions )) == null ? '' : __t) +
'\n</div>\n';
 } ;
__p += '\n';
 if (data.hasDatePicker) { ;
__p += '\n<div class="daterange-selector"></div>\n';
 } ;
__p += '\n';
return __p
}